import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function OutlinedCard(props) {
  const classes = useStyles();
  //const bull = <span className={classes.bullet}>•</span>;

  return (
      
    <Card className={classes.root} variant="outlined">
        
      <CardContent style={{position:'relative'}}>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
        {props.icon}<span style={{position:'absolute',marginTop:'10px',marginLeft:'10px'}}>{props.title}</span>
        </Typography>
        <Typography variant="h5" component="h2">
          {props.data}
        </Typography>
        {/* <Typography className={classes.pos} color="textSecondary">
          {props.icon}
        </Typography> */}
        {/* <Typography variant="body2" component="p">
          well meaning and kindly.
          <br />
          {'"a benevolent smile"'}
        </Typography> */}
      </CardContent>
      {/* <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
}


// WEBPACK FOOTER //
// ./src/component/Card.js